import { FormattedMessage } from "react-intl";
import Button from "@mui/material/Button";

const DirectMessageButton = ({ onClick, ...rest }) => (
  <Button
    color="primary"
    onClick={onClick}
    size="small"
    sx={{
      margin: "7px",
      padding: "0 5px",
    }}
    variant="contained"
    {...rest}
  >
    <FormattedMessage id="messaging.sendMessageButton.title" />
  </Button>
);

export default DirectMessageButton;
